<script lang="ts">
	import {
		MarkdownTokens,
		type MarkdownOptions,
		type Renderers
	} from '@magidoc/plugin-svelte-marked';
	import { twMerge } from 'tailwind-merge';
	import { Disclosure } from '../../../Disclosure';
	import { Txt, type TxtVariant } from '../../../Txt';
	import type { AccordionToken } from '../../utils/accordionExtension/accordionExtension';
	import { getMarkdownStyleContext } from '../../utils/getMarkdownStyleContext/getMarkdownStyleContext';
	import { MarkdownInlineTokens } from '../MarkdownInlineTokens';

	interface Props {
		token: AccordionToken;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}

	let { token, options, renderers }: Props = $props();

	// The label follows the surrounding text's size and colour, which the
	// Markdown root shares through context since renderers only get tokens.
	const style = getMarkdownStyleContext();

	const LABEL_VARIANTS: Record<'small' | 'medium' | 'large', TxtVariant> = {
		small: 'body3',
		medium: 'body2',
		large: 'body1'
	};
	const BOLD_VARIANTS: Record<'small' | 'medium' | 'large', TxtVariant> = {
		small: 'label3',
		medium: 'label3',
		large: 'label2'
	};

	let variant = $derived(LABEL_VARIANTS[style?.size ?? 'large']);
	let boldVariant = $derived(BOLD_VARIANTS[style?.size ?? 'large']);
	let labelClass = $derived(
		twMerge('underline', style?.color === 'gray' ? 'text-gray-500' : 'text-gray-900')
	);
</script>

<Disclosure dataCy="markdown-accordion" class="mb-6">
	{#snippet labelSlot()}
		<Txt component="span" {variant} class={labelClass}>
			<MarkdownInlineTokens
				tokens={token.labelTokens}
				{variant}
				{boldVariant}
				class={labelClass}
				{options}
				{renderers}
			/>
		</Txt>
	{/snippet}
	{#if renderers && options}
		<MarkdownTokens tokens={token.tokens} {renderers} {options} />
	{/if}
</Disclosure>
